import { render, staticRenderFns } from "./QuickLinks.vue?vue&type=template&id=9b7c6750&scoped=true&"
import script from "./QuickLinks.vue?vue&type=script&lang=js&"
export * from "./QuickLinks.vue?vue&type=script&lang=js&"
import style0 from "./QuickLinks.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuickLinks.vue?vue&type=style&index=1&id=9b7c6750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7c6750",
  null
  
)

export default component.exports